import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData, isYouTubeURL } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import { history } from "../../../../store/configure/configureStore";
import { setUnblock } from "../../../../navigation/navigationBlocker";

import YouTubeManagementView from "./YouTubeManagementView";
import { youtubeUrlConstants } from "../../../../store/YouTubeManagement/YouTubeManagementReducer";
import { USER_MANAGEMENT, CONTENT_DETAIL } from "../../../../navigation/routes";
import {
  getYouTubeList,
  resetRedirected,
  addMultipleYouTubeVideoPublished,
  addYouTubeVideoByUrl,
  setActiveNavigationTab,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
  resetPageAndLimit,
  setUpdatedRowTags,
  setUpdatedRowCategory,
  resetRowTags,
  resetRowCategory,
  setShowSelection,
  resetShowSelection,
  resetNavigatingToOtherPageWarningModal,
  setSelectedMultipleRows,
  resetSelectedMultipleRows,
  setNavigatingToOtherPageWarningModal,
  setNavigatingToOtherTabWarningModal,
} from "../../../../store/YouTubeManagement/YouTubeManagementActions";
import {
  getRoleList,
  getStatusList,
  getTagsList,
  updateRowsPerPage,
  getLanguagesList,
  getCategoryList,
  getYouTubeSourceList,
} from "../../../../store/master/masterActions";

class YouTubeManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        searchValue: {
          titleSearch: this.props.titleSearch || "",
          statusSearch: this.props.statusSearch || "",
          languageSearch: this.props.languageSearch || "",
          channelSearch: this.props.channelSearch || "",
        },
        searchValueVideosByUrl: {
          titleSearchByUrl: this.props.videosByUrlTitleSearch || "",
          statusSearch: this.props.videosByUrlStatusSearch || "",
          languageSearch: this.props.videosByUrlLanguageSearch || "",
          channelSearch: this.props.videosByUrlChannelSearch || "",
        },
        videoUrl: "",
      },
      showModal: {
        showWarningModal: false,
        showUploadVideoModal: false,
        showAddGenreModal: false,
        showAddCategoryModal: false,
        showWarningForRowGenres: false,
        showWarningForRowTagsWhenNavigating: false,
        showWarningForRowTagsWhenNavigatingToOtherTab: false,
        showWarningForCategorySelection: false,
      },
      showSelection:
        this.props.rowTags?.length > 0 ||
        this.props.selectedMultipleRowVideo?.length > 0 ||
        this.props.showSelection
          ? true
          : false,
      multipleVideoIds:
        this?.props.selectedMultipleRowVideo
          ?.map((item) => item?.selectedRows)
          ?.flat() || [],
      multipleVideoIdsForLogicHandling:
        this?.props.selectedMultipleRowVideo || [],
      videoGenre: [],
      videoCategory: "",
      // genreWithVideoId: [], //it is used for bulk publish
      genreWithVideoId: this.props.rowTags || [], //it is used for bulk publish
      categoryWithVideoId: this.props.rowCategory || [], //it is used for bulk publish
      currentPage: this.props.currentPage,
      rowsPerPage: {
        label: `${this.props.currentLimit}`,
        value: this.props.currentLimit,
      },
      currentPageVideoByUrl: this.props.currentPageVideoByUrl,
      rowsPerPageVideoByUrl: {
        label: `${this.props.currentLimitVideoByUrl}`,
        value: this.props.currentLimitVideoByUrl,
      },
      errors: {},
      //
      updatedYoutubeListWithIsSelectionFlagList:
        this?.props?.updatedYoutubeListWithIsSelectionFlag?.docs.length > 0 &&
        this.props.updatedYoutubeListWithIsSelectionFlag,
    };

    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.handleBulkPublishVideos = this.handleBulkPublishVideos.bind(this);
    //
    this.handleShowSelection = this.handleShowSelection.bind(this);
    this.handleCloseSelection = this.handleCloseSelection.bind(this);
    this.handleSelectedRows = this.handleSelectedRows.bind(this);
    this.selectableRowSelectedOnGenreChange =
      this.selectableRowSelectedOnGenreChange.bind(this);
    //
    this.handlePaste = this.handlePaste.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.onClickVideoGenreAdd = this.onClickVideoGenreAdd.bind(this);
    this.onClickVideoCategoryAdd = this.onClickVideoCategoryAdd.bind(this);
    this.onChangeVideoUrlInput = this.onChangeVideoUrlInput.bind(this);
    this.onChangeGenres = this.onChangeGenres.bind(this);
    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.handleInitialGenresOfRow = this.handleInitialGenresOfRow.bind(this);
    this.handleRemoveGenres = this.handleRemoveGenres.bind(this);
    //
    this.handleTabChange = this.handleTabChange.bind(this);
    //
    this.onClickStatusDropDownFilterOptions =
      this.onClickStatusDropDownFilterOptions.bind(this);
    this.onClickLanguageDropDownFilterOptions =
      this.onClickLanguageDropDownFilterOptions.bind(this);
    this.onClickChannelNameDropDownFilterOptions =
      this.onClickChannelNameDropDownFilterOptions.bind(this);
    //
    this.handleUploadVideoByUrl = this.handleUploadVideoByUrl.bind(this);
    //
    this.onTabChangeSaveAsDraft = this.onTabChangeSaveAsDraft.bind(this);
    this.onClickSaveASDraftDiscard = this.onClickSaveASDraftDiscard.bind(this);
    //
    this.handleOnClickReset = this.handleOnClickReset.bind(this);
  }

  componentDidUpdate(prevProps) {
    // console.log("updated multipleVideoIds", this.state?.multipleVideoIds);
    this.selectableRowSelectedOnGenreChange(); //select rows programmatically

    // console.log("prevProps", prevProps);
    const { page, limit } = this.props?.youtubeList;
    // console.log("update log", page);
    //--------------------------update current page and limit based on response
    if (
      this.props.activeNavTab ===
      youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
    ) {
      if (prevProps.youtubeList?.page !== page) {
        this.setState((prev) => ({
          ...prev,
          currentPage: page,
          rowsPerPage: { label: `${limit}`, value: limit },
        }));
      }
    }

    if (this.props.activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL) {
      const { page, limit } = this.props?.youtubeList;
      if (prevProps.youtubeList?.page !== page) {
        this.setState((prev) => ({
          ...prev,
          currentPageVideoByUrl: page,
          rowsPerPageVideoByUrl: { label: `${limit}`, value: limit },
        }));
      }
    }

    if (
      prevProps?.activeNavTab !== this.props.activeNavTab &&
      this.props.accessToken
    ) {
      this.fetchYouTubeList();
    }

    //update then showWarningForRowTagsWhenNavigating when row genres are changed
    if (
      prevProps.showWarningForRowTagsWhenNavigating !==
      this?.props.showWarningForRowTagsWhenNavigating
    ) {
      this.setState((prev) => ({
        ...prev,
        showModal: {
          ...prev.showModal,
          showWarningForRowTagsWhenNavigating:
            this?.props.showWarningForRowTagsWhenNavigating,
        },
      }));
    }

    //persisted row selection
    if (
      prevProps.selectedMultipleRowVideo !==
      this?.props.selectedMultipleRowVideo
    ) {
      //get only selectedRows Data
      const selectedRows = this?.props.selectedMultipleRowVideo
        ?.map((item) => item?.selectedRows)
        ?.flat();

      this.setState((prev) => ({
        ...prev,
        // multipleVideoIds: this?.props.selectedMultipleRowVideo,
        multipleVideoIds: selectedRows,
        multipleVideoIdsForLogicHandling: this?.props.selectedMultipleRowVideo,
      }));
    }

    if (prevProps.showSelection !== this?.props.showSelection) {
      this.setState((prev) => ({
        ...prev,
        showSelection: this?.props.showSelection,
      }));
    }

    if (prevProps.rowTags !== this?.props.rowTags) {
      this.setState((prev) => ({
        ...prev,
        genreWithVideoId: this?.props.rowTags,
      }));
    }

    if (prevProps.rowCategory !== this?.props.rowCategory) {
      this.setState((prev) => ({
        ...prev,
        categoryWithVideoId: this?.props.rowCategory,
      }));
    }

    if (prevProps.youtubeList !== this?.props.youtubeList) {
      this.onSavedGenreChanged();
    }
  }

  componentDidMount() {
    // console.log("component did mount location", this.props);

    //on refresh the page remove the selection
    this.beforeUnloadListener = (e) => {
      // Set flag for future reloads
      sessionStorage.setItem("isRefreshed", "true");
    };

    // // Check if the page was refreshed
    const isRefreshed = sessionStorage.getItem("isRefreshed");

    if (isRefreshed) {
      const handleRefresh = async () => {
        // Handle the logic after refresh
        await this.props.resetRowTags();
        await this.props.resetRowCategory();
        await this.props.resetSelectedMultipleRows();
        this.props.resetShowSelection();
        // console.log("Page was refreshed");
        sessionStorage.removeItem("isRefreshed");
      };

      handleRefresh();
    }

    // // Attach the event listener
    window.addEventListener("beforeunload", this.beforeUnloadListener);

    // Block sidebar navigation when row are selected,
    this.unblock = history.block((location, action) => {
      // console.log("location", location);
      const { showSelection, selectedMultipleRowVideo } = this.props;
      const showSelectionIsTrue = showSelection;
      const isRowsSelected = selectedMultipleRowVideo?.length > 0;
      const shouldBlock = showSelectionIsTrue && isRowsSelected; // replace with your condition

      // Check if the current path should not block navigation
      const shouldAllowNavigation =
        location?.pathname?.includes("/media/content-detail/youtube") ||
        location?.pathname?.includes("/media/youtube-management");

      //allow navigation only for the above paths
      if (shouldBlock && !shouldAllowNavigation) {
        // Prevent navigation
        this.props.setNavigatingToOtherPageWarningModal(
          true,
          location?.pathname
        );
        return false; // Prevent the default behavior
      }
    });
    setUnblock(this.unblock); // Set the unblock function globally

    //---------------------

    this.fetchYouTubeList();
    this.props.getStatusList();
    this.props.getTagsList();
    this.props.getLanguagesList();
    this.props.getCategoryList();
    this.props.getYouTubeSourceList();
  }

  componentWillUnmount() {
    // Remove the beforeunload event listener
    window.removeEventListener("beforeunload", this.beforeUnloadListener);
    sessionStorage.removeItem("isRefreshed");

    if (!window?.location?.pathname.includes(CONTENT_DETAIL)) {
      this.props?.resetShowSelection();
    } else {
      const path = window?.location?.pathname;
      const id = path.split("/").pop(); // Split by '/' to get the id of video
      localStorage?.setItem("videoId", id);
    }
  }

  //--------------------------handle row per page

  handleTableRowsChange = (value) => {
    const { activeNavTab } = this.props;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;

    // Update state based on active tab
    this.setState(
      (prevState) => ({
        ...prevState,
        rowsPerPage: isActiveTabByCron ? value : prevState?.rowsPerPage,
        currentPage: isActiveTabByCron ? 1 : prevState?.currentPage,
        rowsPerPageVideoByUrl: isActiveTabByUrl
          ? value
          : prevState?.rowsPerPageVideoByUrl,
        currentPageVideoByUrl: isActiveTabByUrl
          ? 1
          : prevState?.currentPageVideoByUrl,
      }),
      () => this.fetchYouTubeList()
    );
  };

  handleChangePage = (page) => {
    const { activeNavTab, resetSelectedMultipleRows, resetRowTags } =
      this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    console.log("isActiveTabByCron", isActiveTabByCron);
    // Update the current page state
    this.setState(
      (prevState) => ({
        ...prevState,
        currentPage: isActiveTabByCron ? page : prevState?.currentPage,
        currentPageVideoByUrl: isActiveTabByUrl
          ? page
          : prevState?.currentPageVideoByUrl,
      }),
      () => this.fetchYouTubeList()
    );

    // Reset common actions
    // this.handleOnClickReset();
    // resetSelectedMultipleRows();
    // resetRowTags();
  };

  //--------------------------Search videos

  // onChangeSearchInput = (e) => {
  //   const { value } = e.target;

  //   const { activeNavTab } = this.props;
  //   const isActiveTabByCron =
  //     activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
  //   const isActiveTabByUrl =
  //     activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

  //   this.setState(
  //     (prev) => ({
  //       ...prev,
  //       fields: {
  //         ...prev.fields,
  //         searchValue: {
  //           ...prev.fields.searchValue,
  //           titleSearch: isActiveTabByCron
  //             ? value
  //             : prev?.fields?.searchValue?.titleSearch,
  //         },
  //         searchValueVideosByUrl: {
  //           ...prev.fields.searchValueVideosByUrl,
  //           titleSearchByUrl: isActiveTabByUrl
  //             ? value
  //             : prev?.fields?.searchValueVideosByUrl?.titleSearchByUrl,
  //         },
  //       },
  //     }),
  //     () => {
  //       if (value === "") {
  //         //get list
  //         this.handleClear();
  //       }
  //     }
  //   );
  // };

  onChangeSearchInput = (e) => {
    // const { value } = e.target;
    const field = e.target.name;
    const { value } = e.target;

    console.log("field", field);

    const { activeNavTab } = this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    this.setState(
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors[field]; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            searchValue: {
              ...prevState.fields.searchValue,
              titleSearch: isActiveTabByCron
                ? value
                : prevState?.fields?.searchValue?.titleSearch,
            },
            searchValueVideosByUrl: {
              ...prevState.fields.searchValueVideosByUrl,
              titleSearchByUrl: isActiveTabByUrl
                ? value
                : prevState?.fields?.searchValueVideosByUrl?.titleSearchByUrl,
            },
          },
          errors: updatedErrors,
        };
      },
      () => {
        if (value === "") {
          //get list
          this.handleClear();
        }
      }
    );
  };
  //--------------------------On Search Click

  onClickSearch = () => {
    var fieldsOfYoutubeChannel = this.state.fields?.searchValue;
    var fieldsOfYoutubeByURL = this.state.fields?.searchValueVideosByUrl;

    const { activeNavTab } = this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    const validationRequiredFields = isActiveTabByCron
      ? ["titleSearch"]
      : ["titleSearchByUrl"];

    const validatorFields = {
      // required: ["searchValue"],
      required: validationRequiredFields,
    };

    const formDataBasedOnActiveTab = isActiveTabByCron
      ? fieldsOfYoutubeChannel
      : fieldsOfYoutubeByURL;

    const { errors } = validator.validate(
      validatorFields,
      trimFormData(formDataBasedOnActiveTab)
      // fields
    );

    console.log("trimed data", errors);

    // Add custom error message
    // const updatedErrors = {
    //   ...errors,
    //   searchValue: errors?.searchValue && "Please enter valid input",
    //   searchValueForYoutubePick:
    //     errors?.searchValueForYoutubePick && "Please enter valid input",
    // };

    const updatedErrorsOfYoutubeChannel = {
      ...errors,
      titleSearch: errors?.titleSearch && "Please enter valid input",
    };

    const updatedErrorsOfYoutubeByURL = {
      ...errors,
      titleSearchByUrl: errors?.titleSearchByUrl && "Please enter valid input",
    };

    const errorsBasedOnActiveTab = isActiveTabByCron
      ? updatedErrorsOfYoutubeChannel
      : updatedErrorsOfYoutubeByURL;

    console.log("updatedErrors", errorsBasedOnActiveTab);

    this.setState({ ...this.state, errors: errorsBasedOnActiveTab });

    if (!Object.keys(errors).length) {
      // Update the current page state
      this.setState(
        (prevState) => ({
          ...prevState,
          currentPage: isActiveTabByCron ? 1 : prevState?.currentPage,
          currentPageVideoByUrl: isActiveTabByUrl
            ? 1
            : prevState?.currentPageVideoByUrl,
        }),
        () => this.fetchYouTubeList()
      );
    }
  };

  //--------------------------clear the search input based on active tab
  handleClear = () => {
    const { activeNavTab } = this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    this.setState(
      (prev) => {
        const updatedErrors = { ...prev.errors };
        isActiveTabByCron && delete updatedErrors.titleSearch; // Remove the error for the updated field
        isActiveTabByUrl && delete updatedErrors.titleSearchByUrl; // Remove the error for the updated field
        return {
          ...prev,
          fields: {
            ...prev.fields,
            searchValue: {
              ...prev.fields.searchValue,
              titleSearch: isActiveTabByCron
                ? ""
                : prev?.fields?.searchValue?.titleSearch,
            },
            searchValueVideosByUrl: {
              ...prev.fields.searchValueVideosByUrl,
              titleSearchByUrl: isActiveTabByUrl
                ? ""
                : prev?.fields?.searchValueVideosByUrl?.titleSearchByUrl,
            },
          },
          errors: updatedErrors,
        };
      },
      () => this.fetchYouTubeList()
    );
  };

  //--------------------------filter based on status

  onClickStatusDropDownFilterOptions = (value) => {
    const { activeNavTab } = this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          searchValue: {
            ...prev.fields.searchValue,
            statusSearch: isActiveTabByCron
              ? value?._id
              : prev?.fields?.searchValue?.statusSearch,
          },

          searchValueVideosByUrl: {
            ...prev.fields.searchValueVideosByUrl,
            statusSearch: isActiveTabByUrl
              ? value?._id
              : prev?.fields?.searchValueVideosByUrl?.statusSearch,
          },
        },
        currentPage: isActiveTabByCron ? 1 : prev?.currentPage,
        currentPageVideoByUrl: isActiveTabByUrl
          ? 1
          : prev?.currentPageVideoByUrl,
      }),
      () => {
        this.fetchYouTubeList();
        // this.handleCloseSelection();
        this.props.resetRowTags();
        this.props.resetRowCategory();
        this.props.resetNavigatingToOtherPageWarningModal();
        this.props.resetSelectedMultipleRows(); //reset the redux state of selected rows
        this.handleOnClickReset(); //reset the state
      }
    );
  };

  //--------------------------filter based on language

  onClickLanguageDropDownFilterOptions = (value) => {
    const { activeNavTab } = this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          searchValue: {
            ...prev.fields.searchValue,
            languageSearch: isActiveTabByCron
              ? value?._id
              : prev?.fields?.searchValue?.languageSearch,
          },

          searchValueVideosByUrl: {
            ...prev.fields.searchValueVideosByUrl,
            languageSearch: isActiveTabByUrl
              ? value?._id
              : prev?.fields?.searchValueVideosByUrl?.languageSearch,
          },
        },
        currentPage: isActiveTabByCron ? 1 : prev?.currentPage,
        currentPageVideoByUrl: isActiveTabByUrl
          ? 1
          : prev?.currentPageVideoByUrl,
      }),
      () => {
        this.fetchYouTubeList();
        // this.handleCloseSelection();
        this.props.resetRowTags();
        this.props.resetRowCategory();
        this.props.resetNavigatingToOtherPageWarningModal();
        this.props.resetSelectedMultipleRows(); //reset the redux state of selected rows
        this.handleOnClickReset(); //reset the state
      }
    );
  };

  //--------------------------filter based on channel name

  onClickChannelNameDropDownFilterOptions = (value) => {
    const { activeNavTab } = this.props;
    const isActiveTabByCron =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const isActiveTabByUrl =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    this.setState(
      (prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          searchValue: {
            ...prev.fields.searchValue,
            channelSearch: isActiveTabByCron
              ? value?.channelId
              : prev?.fields?.searchValue?.channelSearch,
          },

          searchValueVideosByUrl: {
            ...prev.fields.searchValueVideosByUrl,
            channelSearch: isActiveTabByUrl
              ? value?.channelId
              : prev?.fields?.searchValueVideosByUrl?.channelSearch,
          },
        },
        currentPage: isActiveTabByCron ? 1 : prev?.currentPage,
        currentPageVideoByUrl: isActiveTabByUrl
          ? 1
          : prev?.currentPageVideoByUrl,
      }),
      () => {
        this.fetchYouTubeList();
        // this.handleCloseSelection();
        this.props.resetRowTags();
        this.props.resetRowCategory();
        this.props.resetNavigatingToOtherPageWarningModal();
        this.props.resetSelectedMultipleRows(); //reset the redux state of selected rows
        this.handleOnClickReset(); //reset the state
      }
    );
  };

  //--------------------------API Call

  fetchYouTubeList = () => {
    const { activeNavTab, getYouTubeList } = this.props;

    const {
      currentPage,
      currentPageVideoByUrl,
      rowsPerPage,
      rowsPerPageVideoByUrl,
    } = this.state;
    // console.log("current state", this.state);

    // Determine the appropriate search values based on the active tab
    const searchValues =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? this.state?.fields?.searchValueVideosByUrl
        : this.state?.fields?.searchValue;

    const searchValuesForTitle =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON &&
      this.state?.fields?.searchValue?.titleSearch;

    const searchValuesForTitleByURL =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL &&
      this.state?.fields?.searchValueVideosByUrl?.titleSearchByUrl;

    const { statusSearch, languageSearch, channelSearch } = searchValues;

    // Create data object for the search request
    // const data = {
    //   searchString: titleSearch?.trim(),
    //   status: statusSearch,
    //   languageId: languageSearch,
    //   channelId: channelSearch,
    // };

    const titleSearchBasedOnActiveNavTab =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? searchValuesForTitleByURL
        : searchValuesForTitle;

    const data = {
      searchString: titleSearchBasedOnActiveNavTab?.trim(),
      status: statusSearch,
      languageId: languageSearch,
      channelId: channelSearch,
    };

    // Determine the appropriate pagination values and URL type
    const [page, limit, urlType] =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? [
            currentPageVideoByUrl,
            rowsPerPageVideoByUrl?.value,
            youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL,
          ]
        : [
            currentPage,
            rowsPerPage?.value,
            youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON,
          ];

    // Fetch the YouTube list data
    getYouTubeList(data, page, limit, urlType);
  };

  //--------------------------Modal

  showWarningPopup = () => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showWarningModal: true },
    }));
  };

  showUploadUrlPopup = () => {
    this.setState((prevState) => ({
      showModal: { ...prevState.showModal, showUploadVideoModal: true },
    }));
  };

  showTabChangePopup = () => {
    this.setState((prevState) => ({
      showModal: {
        ...prevState.showModal,
        showWarningForRowTagsWhenNavigatingToOtherTab: true,
      },
    }));
  };

  showAddGenrePopup = () => {
    this.setState(
      (prevState) => ({
        showModal: { ...prevState.showModal, showAddGenreModal: true },
      })
      // console.log("add genre popup state", this.state)
    );
  };

  showAddCategoryPopup = () => {
    this.setState(
      (prevState) => ({
        showModal: { ...prevState.showModal, showAddCategoryModal: true },
      })
      // console.log("add genre popup state", this.state)
    );
  };

  showWarningPopupForRowGenresOnNavChange = () => {
    this.setState((prevState) => ({
      showModal: {
        ...prevState.showModal,
        showWarningForRowGenres: true,
      },
    }));
  };

  showWarningPopupForCategorySelection = () => {
    this.setState((prevState) => ({
      showModal: {
        ...prevState.showModal,
        showWarningForCategorySelection: true,
      },
    }));
  };

  onCloseModal = () => {
    this.setState(
      (prevState) => ({
        fields: { ...prevState?.fields, videoUrl: "" },
        showModal: {
          showWarningModal: false,
          showUploadVideoModal: false,
          showAddGenreModal: false,
          showAddCategoryModal: false,
          showWarningForRowGenres: false,
          showWarningForRowTagsWhenNavigating: false,
          showWarningForRowTagsWhenNavigatingToOtherTab: false,
          showWarningForCategorySelection: false,
        },
        errors: {},
      }),
      this.props.resetNavigatingToOtherPageWarningModal()
    );
  };

  //--------------------------handle copy paste
  handlePaste = async () => {
    try {
      // Get the text from the clipboard
      const clipboardText = await navigator.clipboard.readText();
      this.setState((prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          // searchValue: { ...prev.fields.searchValue },
          videoUrl: clipboardText,
        },
      }));
    } catch (err) {
      console.error("Failed to read clipboard contents: ", err);
    }
  };

  onChangeVideoUrlInput = (e) => {
    const { value } = e.target;
    this.setState((prev) => ({
      ...prev,
      fields: {
        ...prev.fields,
        videoUrl: value,
      },
      errors: {},
    }));
  };

  handleCurrentPage = () => {
    if (this.props.activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL) {
      return this.setState((prev) => ({ ...prev, currentPageVideoByUrl: 1 }));
    } else {
      return this.setState((prev) => ({ ...prev, currentPage: 1 }));
    }
  };

  //--------------------------handle Column genres

  handleInitialGenresOfRow = (row) => {
    // console.log("initial genre", row);

    // const savedGenre =
    //   row?.tag?.length > 0 ? row?.tag?.map((item) => item?.tag) : [];
    const savedGenre =
      row?.subCategory?.length > 0
        ? row?.subCategory?.map((item) => item?.tag)
        : [];

    const createObject = () => {
      return {
        objectId: row._id,
        genres: [...savedGenre],
      };
    };

    console.log("savedGeraner", savedGenre);

    this.setState(
      (prevState) => {
        const existingObjectIndex = prevState.genreWithVideoId?.findIndex(
          (item) => item.objectId === row._id
        );

        // if (existingObjectIndex !== -1) {
        //   // Object with the same objectId already exists, do nothing
        //   return null;
        // }

        if (existingObjectIndex !== -1) {
          // Update the genres of the existing object
          const updatedGenreWithVideoId = [...prevState.genreWithVideoId];
          const existingGenres =
            updatedGenreWithVideoId[existingObjectIndex].genres;

          // Combine previous and new genres, ensuring no duplicates
          const combinedGenres = Array.from(
            new Set([...existingGenres, ...savedGenre])
          );

          //if tags are removed then only update with existingGenres
          const genreList = updatedGenreWithVideoId[existingObjectIndex]
            ?.removedGenre
            ? existingGenres
            : combinedGenres;

          updatedGenreWithVideoId[existingObjectIndex] = {
            ...updatedGenreWithVideoId[existingObjectIndex],
            // genres: [...savedGenre],
            // genres: combinedGenres,
            genres: genreList,
          };

          return {
            genreWithVideoId: updatedGenreWithVideoId,
          };
        }

        // Object doesn't exist, create a new one
        const updatedGenreWithVideoId = [
          ...prevState.genreWithVideoId,
          createObject(),
        ];

        return {
          ...prevState,
          genreWithVideoId: updatedGenreWithVideoId,
        };
      },
      () => {
        console.log("states initial state", this.state);
      }
    );
  };

  handleRemoveGenres = (index, row) => {
    console.log("index of remove genre", index);

    this.setState(
      (prevState) => {
        const updatedGenreWithVideoId = prevState.genreWithVideoId.map(
          (item) => {
            if (item.objectId === row._id) {
              // Remove the genre at the specified index
              const updatedGenres = item.genres.filter((_, i) => i !== index);

              // Return the updated object
              return {
                ...item,
                genres: updatedGenres,
                removedGenre: true,
              };
            }
            return item;
          }
        );

        return {
          genreWithVideoId: updatedGenreWithVideoId,
        };
      },
      () => {
        console.log("remove state", this.state);
        this.props.setUpdatedRowTags(this.state?.genreWithVideoId);
      }
    );
  };

  handleRemoveNewlyAddedGenres = (rowData, action) => {
    // Update savedTags by removing the label from it
    const updatedGenreWithVideoId = this.state.genreWithVideoId.map((item) => {
      if (item.objectId === rowData._id) {
        // Remove the genre from the matched object
        const updatedGenres = item.genres.filter(
          (genre) => genre !== action.removedValue?.label
        );
        return { ...item, genres: updatedGenres };
      }
      return item;
    });

    console.log("updatedGenreWithVideoId", updatedGenreWithVideoId);

    // Update the state with the modified genreWithVideoId
    this.setState(
      {
        genreWithVideoId: updatedGenreWithVideoId,
      },
      () => this.props.setUpdatedRowTags(this.state?.genreWithVideoId)
    );
  };

  onChangeGenres = (value) => {
    // console.log("onchange value", value);
    this.setState(
      (prev) => ({
        ...prev,
        videoGenre: value,
        errors: {},
      })
      // () => console.log("video genres state", this.state.videoGenre)
    );
  };

  onClickVideoGenreAdd = (row, genreValues) => {
    // console.log("rowData", row);
    // console.log("genreValues", genreValues);

    const savedGenre =
      // row?.tag?.length > 0 ? row?.tag?.map((item) => item?.tag) : [];
      row?.subCategory?.length > 0
        ? row?.subCategory?.map((item) => item?.tag)
        : [];
    const videoGenreLabels = this?.state?.videoGenre?.map((item) => item.label);
    const newVideoGenreLabels = genreValues?.map((item) => item.label); //this is for newly creatable genres

    const createObject = () => {
      return {
        objectId: row._id,
        genres: [...savedGenre, ...videoGenreLabels, ...newVideoGenreLabels],
        updatedGenre: true,
      };
    };

    //  extracted fields value for validation
    // const fieldsData = {
    //   tag: this?.state?.genreWithVideoId?.[0]?.genres?.[0] || newVideoGenreLabels,
    // };

    const filteredVideoObject = this?.state?.genreWithVideoId?.find(
      (item) => item?.objectId === row?._id
    );

    const extractedGenres = this?.state?.genreWithVideoId.find(
      (item) => item.objectId === row._id && item.genres.length > 0
    )?.genres[0];

    const newlyCreatedGenres =
      newVideoGenreLabels?.length > 0 ? newVideoGenreLabels[0] : "";

    const fieldsData = {
      // genre: extractedGenres || newVideoGenreLabels,
      genre: extractedGenres || newlyCreatedGenres,
    };

    console.log("fieldsData", fieldsData); // Debugging fieldsData

    const validatorFields = { required: ["genre"] };

    const { errors } = validator.validate(
      validatorFields,
      trimFormData(fieldsData)
      // fieldsData
    );

    console.log("errors", errors); // Debugging fieldsData

    this.setState({ ...this.state, errors }, () => {
      if (!Object.keys(errors).length) {
        this.setState(
          (prevState) => {
            const existingObjectIndex = prevState.genreWithVideoId?.findIndex(
              (item) => item.objectId === row._id
            );

            let updatedGenreWithVideoId;

            if (existingObjectIndex !== -1) {
              // Object already exists, update the genres
              updatedGenreWithVideoId = prevState.genreWithVideoId.map(
                (item, index) => {
                  if (index === existingObjectIndex) {
                    return {
                      ...item,
                      genres: [
                        ...new Set([
                          ...item.genres,
                          ...videoGenreLabels,
                          ...newVideoGenreLabels,
                        ]),
                      ], // Merging and removing duplicates
                      updatedGenre: true,
                    };
                  }
                  return item;
                }
              );
            } else {
              // Object doesn't exist, create a new one
              updatedGenreWithVideoId = [
                ...prevState.genreWithVideoId,
                createObject(),
              ];
            }

            console.log("updatedGenreWithVideoId", updatedGenreWithVideoId);

            return {
              ...prevState,
              genreWithVideoId: updatedGenreWithVideoId,
              videoGenre: [],
            };
          },
          () => {
            console.log("states", this.state);
            this.props.setUpdatedRowTags(this.state?.genreWithVideoId);
            this.onCloseModal();
          }
        );
      }
    });
  };

  // onSavedGenreChanged = () => {
  //   const videoIdExtractedFromPath = localStorage.getItem("videoId");
  //   const youtubeList = this.props.youtubeList?.docs;

  //   // Map through genreWithVideoId to merge subCategory from youtubeList when IDs match
  //   const updatedGenreWithVideoId = this.state.genreWithVideoId.map(
  //     (genreObject) => {
  //       // Find matching item in youtubeList based on objectId
  //       const matchingItem = youtubeList?.find(
  //         (item) => item._id === genreObject.objectId
  //       );

  //       if (matchingItem) {
  //         // Extract subCategory tags from the matching item
  //         const subCategories =
  //           matchingItem.subCategory?.map((sub) => sub?.tag) || [];

  //         // Merge subCategories with genres, removing duplicates
  //         return {
  //           ...genreObject,
  //           genres: [...new Set([...subCategories, ...genreObject.genres])],
  //         };
  //       }

  //       return genreObject; // Return unchanged if no match
  //     }
  //   );

  //   // Update the state with the merged data
  //   this.setState({ genreWithVideoId: updatedGenreWithVideoId });

  //   console.log("Updated genreWithVideoId:", updatedGenreWithVideoId);
  // };

  onSavedGenreChanged = () => {
    const videoIdExtractedFromPath = localStorage.getItem("videoId");
    const youtubeList = this.props.youtubeList?.docs;

    // Map through genreWithVideoId to merge subCategory from youtubeList when IDs match
    const updatedGenreWithVideoId = this.state.genreWithVideoId.map(
      (genreObject) => {
        // Only update if the objectId matches the videoId from localStorage
        if (genreObject.objectId === videoIdExtractedFromPath) {
          // Find matching item in youtubeList based on objectId
          const matchingItem = youtubeList?.find(
            (item) => item._id === genreObject.objectId
          );

          if (matchingItem) {
            // Extract subCategory tags from the matching item
            const subCategories =
              matchingItem.subCategory?.map((sub) => sub?.tag) || [];

            // Merge subCategories with genres, removing duplicates
            return {
              ...genreObject,
              genres: [...new Set([...subCategories, ...genreObject.genres])],
            };
          }
        }

        // Return the genreObject unchanged if no match or no update is needed
        return genreObject;
      }
    );

    // Update the state with the merged data
    this.setState({ genreWithVideoId: updatedGenreWithVideoId });

    console.log("Updated genreWithVideoId:", updatedGenreWithVideoId);
  };

  //--------------------------add category
  onChangeCategory = (value, callback) => {
    // console.log("onchange value", value);
    this.setState(
      (prev) => ({
        ...prev,
        videoCategory: value,
        errors: {},
      }),
      () => {
        console.log("video genres state", this.state.videoCategory);
        callback();
      }
    );
  };

  onClickVideoCategoryAdd = (row) => {
    // console.log("rowData", row);
    // console.log("categoryValues", categoryValues);

    const category = this.state.videoCategory || "";
    const createObject = () => {
      return {
        objectId: row._id,
        category: category,
        updatedCategory: true,
      };
    };

    this.setState(
      (prevState) => {
        const existingObjectIndex = prevState.categoryWithVideoId?.findIndex(
          (item) => item.objectId === row._id
        );

        let updatedCategoryWithVideoId;

        if (existingObjectIndex !== -1) {
          // Object already exists, update the category
          updatedCategoryWithVideoId = prevState.categoryWithVideoId.map(
            (item, index) => {
              if (index === existingObjectIndex) {
                return {
                  ...item,
                  category: category,
                  updatedGenre: true,
                };
              }
              return item;
            }
          );
        } else {
          // Object doesn't exist, create a new one
          updatedCategoryWithVideoId = [
            ...prevState.categoryWithVideoId,
            createObject(),
          ];
        }

        return {
          ...prevState,
          categoryWithVideoId: updatedCategoryWithVideoId,
          videoCategory: "",
        };
      },
      () => {
        this.props.setUpdatedRowCategory(this.state?.categoryWithVideoId);
        console.log(this.state.categoryWithVideoId);
        this.onCloseModal();
      }
    );
  };

  //--------------------------save as draft for updated row genres
  onTabChangeSaveAsDraft = (callback) => {
    this.props.setUpdatedRowTags(this.state?.genreWithVideoId);
    this.props.setSelectedMultipleRows(this?.state?.multipleVideoIds);
    this.onCloseModal();
    callback(); //redirect to content detail page callback
  };

  onClickSaveASDraftDiscard = (callback) => {
    this.setState(
      (prev) => ({
        ...prev,
        genreWithVideoId: [],
      }),
      () => {
        this.onCloseModal();
        callback();
      }
    );
  };

  //--------------------------handle selected rows

  // handleSelectedRows = (selectedRows) => {
  //   console.log("Selected Rows: ", selectedRows);

  //   this.setState(
  //     (prevState) => {
  //       // Get the existing multipleVideoIds from the state
  //       const { multipleVideoIds } = prevState;
  //       console.log("prevstate multipleVideoIds", multipleVideoIds);

  //       // Filter out selectedRows that have the same _id as any item in multipleVideoIds
  //       const filteredSelectedRows = selectedRows.filter(
  //         (row) => !multipleVideoIds.some((video) => video._id === row._id) // Check for duplicate _id
  //       );

  //       // Combine filtered new rows with the previous multipleVideoIds
  //       const updatedMultipleVideoIds = [
  //         ...multipleVideoIds,
  //         ...filteredSelectedRows,
  //       ];

  //       // Check if arrays are different by comparing their contents
  //       const areArraysEqual = (a, b) => {
  //         if (a.length !== b.length) return false;
  //         return a.every((item, index) => item._id === b[index]._id);
  //       };

  //       //if not equal then save to redux state
  //       if (
  //         !areArraysEqual(prevState.multipleVideoIds, updatedMultipleVideoIds)
  //       ) {
  //         this.props.setSelectedMultipleRows(updatedMultipleVideoIds);
  //       }

  //       return {
  //         ...prevState,
  //         multipleVideoIds: updatedMultipleVideoIds, // Update state with the filtered rows
  //       };
  //     },
  //     () => {
  //       // this.props.setSelectedMultipleRows(updatedMultipleVideoIds);
  //     }
  //   );
  // };

  handleSelectedRows = (selectedRows) => {
    // console.log("Selected Rows: ", selectedRows);

    const { page } = this.props?.youtubeList;

    // Create a copy of the current state to avoid mutation
    const updatedMultipleVideoIdsWithPage = [
      ...this.state.multipleVideoIdsForLogicHandling,
    ];

    // Check if an object for the current page already exists
    const existingPageIndex = updatedMultipleVideoIdsWithPage.findIndex(
      (item) => item?.page === page
    );

    if (existingPageIndex !== -1) {
      // console.log("exist", selectedRows);

      // If the page exists, set selectedRows
      updatedMultipleVideoIdsWithPage[existingPageIndex].selectedRows =
        selectedRows;
    } else {
      // console.log("dont exist", selectedRows);
      // If the page does not exist, create a new selection object
      const newSelectionForPage = { page: page, selectedRows };
      updatedMultipleVideoIdsWithPage.push(newSelectionForPage);
    }

    const selectedRowsData = updatedMultipleVideoIdsWithPage
      ?.map((item) => {
        return item?.selectedRows;
      })
      ?.flat();

    // console.log("row data", updatedMultipleVideoIdsWithPage);

    // // Check if arrays are different by comparing their contents
    const areArraysEqual = (a, b) => {
      if (a.length !== b.length) return false;

      return a.every((item, index) => {
        const bItem = b[index];
        // Compare all properties of the objects
        return (
          item.page === bItem.page &&
          Array.isArray(item.selectedRows) &&
          Array.isArray(bItem.selectedRows) &&
          item.selectedRows.length === bItem.selectedRows.length &&
          item.selectedRows.every(
            (row, rowIndex) => row === bItem.selectedRows[rowIndex]
          )
        );
      });
    };

    //if not equal then save to redux state
    if (
      !areArraysEqual(
        this.props.selectedMultipleRowVideo,
        updatedMultipleVideoIdsWithPage
      )
    ) {
      // console.log("is not equal");

      this.props.setSelectedMultipleRows(updatedMultipleVideoIdsWithPage);
    }

    this.setState((prev) => ({
      ...prev,
      multipleVideoIds: selectedRowsData,
    }));
  };

  selectableRowSelectedOnGenreChange = (row) => {
    const extractedObjectIds = this?.state?.genreWithVideoId?.map(
      (item) => item?.objectId
    );

    // const savedGenre =
    //   row?.tag?.length > 0
    //     ? row?.tag.map((item) => item?.tag?.toLowerCase())
    //     : [];

    const savedGenre =
      row?.subCategory?.length > 0
        ? row?.subCategory.map((item) => item?.tag?.toLowerCase())
        : [];

    // console.log("savedGenre", savedGenre);

    const extractObject = this?.state?.genreWithVideoId?.filter(
      (item) => item?.objectId === row?._id
    );

    const extractedGenresFromObject = extractObject?.[0]?.genres?.map((tag) =>
      tag.toLowerCase()
    );

    // console.log("extractedGenresFromObject", extractedGenresFromObject);

    // Check if the lengths are different and if the elements are not the same
    const isGenresAreNotSameInRowAndExtractedObject =
      savedGenre?.length !== extractedGenresFromObject?.length &&
      (savedGenre?.some(
        (genre) => !extractedGenresFromObject?.includes(genre)
      ) || // Check if any genre in savedGenre is not in extractedGenresFromObject
        extractedGenresFromObject?.some(
          (genre) => !savedGenre?.includes(genre)
        )) && // Check if any tag in extractedGenresFromObject is not in savedGenre
      extractedGenresFromObject !== undefined;

    // Check if the row._id exists in the extractedObjectIds array
    const isSelected = extractedObjectIds?.includes(row?._id);

    //--------------normally selected rows

    const { selectedMultipleRowVideo } = this.props;
    const extractedRows =
      selectedMultipleRowVideo?.map((item) => item?.selectedRows)?.flat() || [];
    // console.log("extractedRows", extractedRows);

    const persistedSelectedRowData = extractedRows?.map((item) => item?._id);

    const rowIncludedInPersistedSelectedRowData =
      persistedSelectedRowData?.includes(row?._id);

    //
    const selectedRowData = this.state.multipleVideoIds?.map(
      (item) => item?._id
    );

    const rowIncludedInSelectedRowData = selectedRowData?.includes(row?._id);

    //Programmatically select on category changed

    const extractedCategoryObject = this?.state?.categoryWithVideoId?.find(
      (item) => item?.objectId === row?._id
    );

    const isCategoriesAreNotSameInRowAndExtractedCategoryObject =
      extractedCategoryObject &&
      row?.categoryId?.categoryName !==
        extractedCategoryObject?.category?.label;

    // Check if the page was refreshed
    const isRefreshed = sessionStorage.getItem("isRefreshed");

    if (
      (isGenresAreNotSameInRowAndExtractedObject ||
        rowIncludedInPersistedSelectedRowData ||
        rowIncludedInSelectedRowData ||
        isCategoriesAreNotSameInRowAndExtractedCategoryObject) &&
      !isRefreshed
    ) {
      // console.log("is True", row);
      return true; // Select the row
    } else {
      return false; // Do not select the row
    }
  };

  handleOnClickReset = () => {
    this.setState((prev) => ({
      ...prev,
      multipleVideoIds: [],
      genreWithVideoId: [],
      categoryWithVideoId: [],
    }));
  };

  //--------------------------show Row selection checkbox
  handleShowSelection = () => {
    this.setState(
      (prev) => ({ ...prev, showSelection: true }),
      () => this.props.setShowSelection(true)
    );
  };

  handleCloseSelection = () => {
    this.setState(
      (prev) => ({
        ...prev,
        showSelection: false,
        genreWithVideoId: [],
      }),
      () => this.props.resetShowSelection(false)
    );
  };

  //--------------------------bulk publish videos with genres
  // handleBulkPublishVideos = (callback) => {
  //   const createObject = (value, genres) => {
  //     return {
  //       objectId: value,
  //       // genres: genres || [],
  //       subCategory: genres || [],
  //     };
  //   };

  //   // Map videoObject to objects containing objectId and genres
  //   let videoObject = this.state.multipleVideoIds.map((video) => {
  //     // Find if the videoId exists in genreWithVideoId
  //     const matchingTagObject = this.state.genreWithVideoId.find(
  //       (tagObj) => tagObj.objectId === video._id
  //     );

  //     // console.log("matchingTagObject", matchingTagObject);

  //     //if genres are not found in "matchingTagObject" pass this instead of "matchingTagObject"
  //     const extractedGenresFromVideo =
  //       video?.subCategory?.length > 0
  //         ? video?.subCategory?.map((item) => item?.tag)
  //         : [];

  //     // console.log("extractedGenresFromVideo", extractedGenresFromVideo);

  //     // If a match is found, merge the genres; otherwise, return object with empty genres
  //     return createObject(
  //       video._id,
  //       //check if genres are available or "removedGenre" flag is "true"
  //       matchingTagObject?.genres?.length > 0 || matchingTagObject?.removedGenre
  //         ? matchingTagObject?.genres
  //         : extractedGenresFromVideo
  //     );
  //   });

  //   // console.log("videoObject", videoObject);

  //   //get Published status from status list
  //   let statusId = "";
  //   this.props.status?.forEach((item) => {
  //     if (item.status === "Published") {
  //       statusId = item._id;
  //     }
  //   });

  //   if (videoObject?.length > 0 && statusId) {
  //     const data = {
  //       publishedVideoIds: videoObject,
  //       status: statusId,
  //     };

  //     console.log("log data", data);

  //     this.props.addMultipleYouTubeVideoPublished(data, () => {
  //       this.fetchYouTubeList();
  //       this.handleCloseSelection();
  //       this.props.getTagsList();
  //       //
  //       callback();
  //     });
  //   } else {
  //     this.showWarningPopup();
  //   }
  // };

  // handleBulkPublishVideos = (callback) => {
  //   const createObject = (value, genres, categoryId) => {
  //     return {
  //       objectId: value,
  //       subCategory: genres || [],
  //       // categoryId: categoryId || "",
  //       ...(categoryId ? { categoryId } : {}), // Include categoryId only if it's truthy
  //     };
  //   };

  //   console.log("youtubeList", this.props.youtubeList?.docs);

  //   // Map videoObject to objects containing objectId, genres, and categoryId
  //   let videoObject = this.state.multipleVideoIds.map((video) => {
  //     // Find if the videoId exists in genreWithVideoId
  //     const matchingGenreObject = this.state.genreWithVideoId.find(
  //       (tagObj) => tagObj.objectId === video._id
  //     );

  //     // Extract genres from video if not found in matchingGenreObject
  //     const extractedGenresFromVideo =
  //       video?.subCategory?.length > 0
  //         ? video?.subCategory?.map((item) => item?.tag)
  //         : [];

  //     const genres =
  //       matchingGenreObject?.genres?.length > 0 ||
  //       matchingGenreObject?.removedGenre
  //         ? matchingGenreObject?.genres
  //         : extractedGenresFromVideo;

  //     // Find if the videoId exists in categoryWithVideoId
  //     const matchingCategoryObject = this.state.categoryWithVideoId.find(
  //       (catObj) => catObj.objectId === video._id
  //     );

  //     // Assign the categoryId if found
  //     const categoryId = matchingCategoryObject?.updatedCategory
  //       ? matchingCategoryObject?.category?.value
  //       : null;

  //     // Create the video object
  //     return createObject(video._id, genres, categoryId);
  //   });

  //   // Get Published status from status list
  //   let statusId = "";
  //   this.props.status?.forEach((item) => {
  //     if (item.status === "Published") {
  //       statusId = item._id;
  //     }
  //   });

  //   if (videoObject?.length > 0 && statusId) {
  //     const data = {
  //       publishedVideoIds: videoObject,
  //       status: statusId,
  //     };

  //     console.log("log data", data);

  //     this.props.addMultipleYouTubeVideoPublished(data, () => {
  //       this.fetchYouTubeList();
  //       this.handleCloseSelection();
  //       this.props.getTagsList();
  //       //
  //       callback();
  //     });
  //   } else {
  //     this.showWarningPopup();
  //   }
  // };

  // handleBulkPublishVideos = (callback) => {
  //   const createObject = (value, genres, categoryId) => {
  //     return {
  //       objectId: value,
  //       subCategory: genres || [],
  //       categoryId: categoryId || "",
  //       // ...(categoryId ? { categoryId } : {}), // Include categoryId only if it's truthy
  //     };
  //   };

  //   // Find the category ID for "Shorts"
  //   const shortsCategory = this.props.categories?.find(
  //     (item) => item.categoryName === "Shorts"
  //   );
  //   const shortsCategoryId = shortsCategory?._id || null;

  //   // Map videoObject to objects containing objectId, genres, and categoryId
  //   let videoObject = this.state.multipleVideoIds.map((video) => {
  //     // Find if the videoId exists in genreWithVideoId
  //     const matchingGenreObject = this.state.genreWithVideoId.find(
  //       (tagObj) => tagObj.objectId === video._id
  //     );

  //     // Extract genres from video if not found in matchingGenreObject
  //     const extractedGenresFromVideo =
  //       video?.subCategory?.length > 0
  //         ? video?.subCategory?.map((item) => item?.tag)
  //         : [];

  //     const genres =
  //       matchingGenreObject?.genres?.length > 0 ||
  //       matchingGenreObject?.removedGenre
  //         ? matchingGenreObject?.genres
  //         : extractedGenresFromVideo;

  //     // Find the video in youtubeList to check its content type
  //     const youtubeListVideo = this.props.youtubeList?.docs.find(
  //       (doc) => doc._id === video._id
  //     );

  //     // Assign the categoryId for "Shorts" if the contentType is "Shorts"
  //     let categoryId = null;
  //     if (youtubeListVideo?.contentType === "Shorts") {
  //       categoryId = shortsCategoryId; // Assign the ID for Shorts
  //     } else {
  //       // Find if the videoId exists in categoryWithVideoId for other categories
  //       const matchingCategoryObject = this.state.categoryWithVideoId.find(
  //         (catObj) => catObj.objectId === video._id
  //       );
  //       categoryId = matchingCategoryObject?.updatedCategory
  //         ? matchingCategoryObject?.category?.value
  //         : null;
  //     }

  //     // Create the video object
  //     return createObject(video._id, genres, categoryId);
  //   });

  //   // Get Published status from status list
  //   let statusId = "";
  //   this.props.status?.forEach((item) => {
  //     if (item.status === "Published") {
  //       statusId = item._id;
  //     }
  //   });

  //   if (videoObject?.length > 0 && statusId) {
  //     const data = {
  //       publishedVideoIds: videoObject,
  //       status: statusId,
  //     };

  //     console.log("log data", data);

  //     this.props.addMultipleYouTubeVideoPublished(data, () => {
  //       this.fetchYouTubeList();
  //       this.handleCloseSelection();
  //       this.props.getTagsList();
  //       //
  //       callback();
  //     });
  //   } else {
  //     this.showWarningPopup();
  //   }
  // };

  handleBulkPublishVideos = (callback) => {
    const createObject = (value, genres, categoryId) => {
      return {
        objectId: value,
        subCategory: genres || [],
        categoryId: categoryId || "",
      };
    };

    // Find the category ID for "Shorts"
    const shortsCategory = this.props.categories?.find(
      (item) => item.categoryName === "Shorts"
    );
    const shortsCategoryId = shortsCategory?._id || null;

    // Map videoObject to objects containing objectId, genres, and categoryId
    let videoObject = this.state.multipleVideoIds.map((video) => {
      // Find if the videoId exists in genreWithVideoId
      const matchingGenreObject = this.state.genreWithVideoId.find(
        (tagObj) => tagObj.objectId === video._id
      );

      // Extract genres from video if not found in matchingGenreObject
      const extractedGenresFromVideo =
        video?.subCategory?.length > 0
          ? video?.subCategory?.map((item) => item?.tag)
          : [];

      const genres =
        matchingGenreObject?.genres?.length > 0 ||
        matchingGenreObject?.removedGenre
          ? matchingGenreObject?.genres
          : extractedGenresFromVideo;

      // Find the video in youtubeList to check its content type
      const youtubeListVideo = this.props.youtubeList?.docs.find(
        (doc) => doc._id === video._id
      );

      //check content type of video
      const contentType = video?.contentType !== "Shorts";

      // Assign the categoryId for "Shorts" if the contentType is "Shorts"
      let categoryId = null;
      if (youtubeListVideo?.contentType === "Shorts") {
        categoryId = shortsCategoryId; // Assign the ID for Shorts
      } else {
        // Find if the videoId exists in categoryWithVideoId for other categories
        const matchingCategoryObject = this.state.categoryWithVideoId.find(
          (catObj) => catObj.objectId === video._id
        );
        categoryId = matchingCategoryObject?.updatedCategory
          ? matchingCategoryObject?.category?.value
          : contentType
          ? null
          : shortsCategoryId; //set shorts id to prevent warning popup

        //set the saved category id
        if (!matchingCategoryObject) {
          if (
            video?.contentType !== "Shorts" &&
            video?.categoryId?.categoryName
          ) {
            const filteredId = this.props.categories?.filter(
              (item) => item?.categoryName === video?.categoryId?.categoryName
            );
            categoryId = filteredId?.[0]?._id;
          }
        }
      }

      // Create the video object
      return createObject(video._id, genres, categoryId);
    });

    // Check if any videoObject has an empty categoryId
    const hasEmptyCategory = videoObject.some((obj) => !obj.categoryId);

    if (hasEmptyCategory) {
      this.showWarningPopupForCategorySelection(); // Show the popup if category is empty
    } else {
      // Get Published status from status list
      let statusId = "";
      this.props.status?.forEach((item) => {
        if (item.status === "Published") {
          statusId = item._id;
        }
      });

      if (videoObject?.length > 0 && statusId) {
        const data = {
          publishedVideoIds: videoObject,
          status: statusId,
        };

        console.log("log data", data);

        this.props.addMultipleYouTubeVideoPublished(data, () => {
          this.fetchYouTubeList();
          this.handleCloseSelection();
          this.props.getTagsList();
          callback();
        });
      } else {
        this.showWarningPopup();
      }
    }
  };

  //--------------------------handle upload video using url
  // handleUploadVideoByUrl = () => {
  //   const { videoUrl } = this.state.fields;
  //   const data = {
  //     videoUrl: videoUrl,
  //   };

  //   const validatorFields = { required: ["videoUrl"], custom: [] };

  //   validatorFields.custom = [validator.link(["videoUrl"])];

  //   const { errors } = validator.validate(
  //     validatorFields,
  //     data
  //     //  trimFormData(data)
  //   );

  //   this.setState({ ...this.state, errors }, () => {
  //     if (!Object.keys(errors).length) {
  //       this.props.addYouTubeVideoByUrl(data, () => {
  //         this.onCloseModal();
  //         this.fetchYouTubeList(); //call the api based on video type and active tab type
  //       });
  //     }
  //   });
  // };

  handleUploadVideoByUrl = () => {
    const { videoUrl } = this.state.fields;
    const data = {
      videoUrl: videoUrl,
    };

    const validatorFields = { required: ["videoUrl"], custom: [] };

    validatorFields.custom = [validator.link(["videoUrl"])];

    var { errors } = validator.validate(
      validatorFields,
      data
      //  trimFormData(data)
    );

    // Ensure `errors` is an object
    errors = errors || {};

    if (videoUrl) {
      console.log("youtube url", isYouTubeURL.test(videoUrl));

      if (!isYouTubeURL.test(videoUrl.trim())) {
        errors["videoUrl"] = "Please enter valid youtube url";
      }
    }

    this.setState({ ...this.state, errors }, () => {
      if (!Object.keys(errors).length) {
        let videoId;

        const url = new URL(videoUrl);

        if (url.pathname.startsWith("/shorts/")) {
          // Handle Shorts URL
          videoId = url.pathname.split("/shorts/")[1];
        } else {
          // Handle regular YouTube URL
          videoId = url.searchParams.get("v");
        }

        const data = {
          videoId: videoId,
        };

        // console.log("data", data);

        this.props.addYouTubeVideoByUrl(data, () => {
          this.onCloseModal();
          this.fetchYouTubeList(); //call the api based on video type and active tab type
        });
      }
    });
  };

  //--------------------------handle navigation tabs
  handleTabChange = (type, tabKey) => {
    // this.fetchYouTubeList();
    this.props.setActiveNavigationTab(tabKey);
  };

  render() {
    //  --------------------------dropdown options

    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "20", value: 20 },
      { label: "30", value: 30 },
      { label: "50", value: 50 },
      { label: "100", value: 100 },
    ];

    const tagDropDownOptions = this.props?.tags?.map((item) => {
      return {
        label: item?.tag,
        value: item?._id,
      };
    });

    const categoryDropDownOptions = this.props.categories
      ?.filter((item) => item?.categoryName !== "Shorts")
      .map((item) => ({
        label: item?.categoryName,
        value: item?._id,
      }));

    // console.log("this.props.activeNavTab", this.props.activeNavTab);

    const filterBasedOnPersistedData = (options, filteringProperty, id) => {
      var filteredData = [];
      filteredData = options?.filter((item) => item[filteringProperty] === id);
      return filteredData?.[0];
    };

    const persistedData = {
      //this is used for check marking selected filter list
      status: filterBasedOnPersistedData(
        this.props.status,
        "_id",
        this.props.statusSearch
      ),
      language: filterBasedOnPersistedData(
        this.props.languages,
        "_id",
        this.props.languageSearch
      ),
      channel: filterBasedOnPersistedData(
        this.props.youTubeSourceList,
        "channelId",
        this.props.channelSearch
      ),
    };

    const persistedDataVideoByUrl = {
      //this is used for check marking selected filter list
      status: filterBasedOnPersistedData(
        this.props.status,
        "_id",
        this.props.videosByUrlStatusSearch
      ),
      language: filterBasedOnPersistedData(
        this.props.languages,
        "_id",
        this.props.videosByUrlLanguageSearch
      ),
      channel: filterBasedOnPersistedData(
        this.props.youTubeSourceList,
        "channelId",
        this.props.videosByUrlChannelSearch
      ),
    };

    //handled persisted data for different active tabs here
    const dynamicPersistedData =
      this.props.activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? persistedDataVideoByUrl
        : persistedData;

    //handled page for different active tabs here
    const dynamicPage =
      this.props.activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? this.state.currentPageVideoByUrl
        : this.state.currentPage;

    //handled page limit for different active tabs here
    const dynamicPageLimit =
      this.props.activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? this.state.rowsPerPageVideoByUrl
        : this.state.rowsPerPage;

    return (
      <YouTubeManagementView
        unblock={this.unblock}
        //all the states
        fields={this.state.fields}
        genreWithVideoId={this.state.genreWithVideoId}
        categoryWithVideoId={this.state.categoryWithVideoId}
        multipleVideoIds={this.state.multipleVideoIds}
        youtubeList={this.props.youtubeList}
        showRowsPerPage={this.props.showRowsPerPage}
        currentPage={dynamicPage}
        rowsPerPage={dynamicPageLimit}
        showSelection={this.state.showSelection}
        errors={this.state.errors}
        activeNavTab={this.props.activeNavTab}
        selectedMultipleRowVideo={this.props.selectedMultipleRowVideo}
        //input handler
        onChangeSearchInput={this.onChangeSearchInput}
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        onChangeVideoUrlInput={this.onChangeVideoUrlInput}
        onChangeGenres={this.onChangeGenres}
        onChangeCategory={this.onChangeCategory}
        handleInitialGenresOfRow={this.handleInitialGenresOfRow}
        //
        handlePaste={this.handlePaste}
        handleClear={this.handleClear}
        onClickVideoGenreAdd={this.onClickVideoGenreAdd}
        onClickVideoCategoryAdd={this.onClickVideoCategoryAdd}
        handleRemoveGenres={this.handleRemoveGenres}
        handleRemoveNewlyAddedGenres={this.handleRemoveNewlyAddedGenres}
        //table selection handler
        handleShowSelection={this.handleShowSelection}
        handleCloseSelection={this.handleCloseSelection}
        handleSelectedRows={this.handleSelectedRows}
        selectableRowSelectedOnGenreChange={
          this.selectableRowSelectedOnGenreChange
        }
        //
        handleTabChange={this.handleTabChange}
        //API's
        onClickSearch={this.onClickSearch}
        handleBulkPublishVideos={this.handleBulkPublishVideos}
        handleUploadVideoByUrl={this.handleUploadVideoByUrl}
        //dropdown options
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        tagDropDownOptions={tagDropDownOptions}
        categoryDropDownOptions={categoryDropDownOptions}
        //master states
        status={this.props.status}
        languages={this.props.languages}
        youTubeSourceList={this.props.youTubeSourceList}
        //table header filter
        onClickStatusDropDownFilterOptions={
          this.onClickStatusDropDownFilterOptions
        }
        onClickLanguageDropDownFilterOptions={
          this.onClickLanguageDropDownFilterOptions
        }
        onClickChannelNameDropDownFilterOptions={
          this.onClickChannelNameDropDownFilterOptions
        }
        //
        userPermissions={this.props.userPermissions}
        userRole={this.props.userRole}
        //
        persistedData={dynamicPersistedData}
        onTabChangeSaveAsDraft={this.onTabChangeSaveAsDraft}
        onClickSaveASDraftDiscard={this.onClickSaveASDraftDiscard}
        //Modal controls
        showModal={this.state.showModal}
        showWarningPopup={this.showWarningPopup}
        showUploadUrlPopup={this.showUploadUrlPopup}
        showTabChangePopup={this.showTabChangePopup}
        showAddGenrePopup={this.showAddGenrePopup}
        showAddCategoryPopup={this.showAddCategoryPopup}
        showWarningPopupForRowGenresOnNavChange={
          this.showWarningPopupForRowGenresOnNavChange
        }
        handleCloseModal={this.onCloseModal}
        //
        resetRowTags={this.props.resetRowTags}
        resetRowCategory={this.props.resetRowCategory}
        resetNavigatingToOtherPageWarningModal={
          this.props.resetNavigatingToOtherPageWarningModal
        }
        handleOnClickReset={this.handleOnClickReset}
        //
        resetSelectedMultipleRows={this.props.resetSelectedMultipleRows}
        redirectingLink={this.props.redirectingLink}
        setNavigatingToOtherPageWarningModal={
          this.props.setNavigatingToOtherPageWarningModal
        }
        setNavigatingToOtherTabWarningModal={
          this.props.setNavigatingToOtherTabWarningModal
        }
        redirectingTab={this.props.redirectingTab}
      />
    );
  }
}

YouTubeManagementContainer.propTypes = {};

const mapStateToProps = (state) => ({
  accessToken: state?.auth?.accessToken,
  youtubeList: state.youtubeManagement.youtubeList,
  isRedirected: state.youtubeManagement.redirected,
  currentPage: state.youtubeManagement.currentPage,
  currentLimit: state.youtubeManagement.currentLimit,
  currentPageVideoByUrl: state.youtubeManagement.currentPageVideoByUrl,
  currentLimitVideoByUrl: state.youtubeManagement.currentLimitVideoByUrl,
  showSelection: state.youtubeManagement.showSelection,
  selectedMultipleRowVideo: state.youtubeManagement.selectedMultipleRowVideo,
  rowTags: state.youtubeManagement.rowTags,
  rowCategory: state.youtubeManagement.rowCategory,
  activeNavTab: state.youtubeManagement.activeNavTab,
  showRowsPerPage: state.master.showRowsPerPage,
  //
  status: state.master.status,
  tags: state.master.tags,
  languages: state.master.languages,
  categories: state.master.categories,
  youTubeSourceList: state.master.youTubeSourceList,
  userPermissions: state.auth.userPermissions,
  userRole: state.auth.userRole,
  //
  titleSearch: state.youtubeManagement.titleSearch,
  statusSearch: state.youtubeManagement.statusSearch,
  languageSearch: state.youtubeManagement.languageSearch,
  channelSearch: state.youtubeManagement.channelSearch,
  //
  videosByUrlTitleSearch: state.youtubeManagement.videosByUrlTitleSearch,
  videosByUrlStatusSearch: state.youtubeManagement.videosByUrlStatusSearch,
  videosByUrlLanguageSearch: state.youtubeManagement.videosByUrlLanguageSearch,
  videosByUrlChannelSearch: state.youtubeManagement.videosByUrlChannelSearch,
  //
  showWarningForRowTagsWhenNavigating:
    state.youtubeManagement.showWarningForRowTagsWhenNavigating,
  selectedMultipleRowVideo: state.youtubeManagement.selectedMultipleRowVideo,
  updatedYoutubeListWithIsSelectionFlag:
    state.youtubeManagement.updatedYoutubeListWithIsSelectionFlag,
  redirectingLink: state.youtubeManagement.redirectingLink,
  redirectingTab: state.youtubeManagement.redirectingTab,
});

export default connect(mapStateToProps, {
  getYouTubeList,
  addMultipleYouTubeVideoPublished,
  //
  getStatusList,
  getLanguagesList,
  getCategoryList,
  getTagsList,
  getYouTubeSourceList,
  addYouTubeVideoByUrl,
  //
  updateRowsPerPage,
  setActiveNavigationTab,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
  resetPageAndLimit,
  //
  setUpdatedRowTags,
  setUpdatedRowCategory,
  resetRowTags,
  resetRowCategory,
  setShowSelection,
  resetShowSelection,
  resetNavigatingToOtherPageWarningModal,
  setSelectedMultipleRows,
  resetSelectedMultipleRows,
  setNavigatingToOtherPageWarningModal,
  setNavigatingToOtherTabWarningModal,
})(YouTubeManagementContainer);
